/**
 * お知らせ表示の共有定数（一般ユーザー向け画面: 一覧/バナー/モーダル）
 * バッジのクラスマッピングは Admin 画面（pages/admin/Announcements.tsx）と揃える。
 */
import type {
  AnnouncementCategory,
  AnnouncementSeverity,
} from '@df-gate-share/shared';

export const CATEGORY_BADGE_CLASS: Record<AnnouncementCategory, string> = {
  maintenance: 'badge--warning',
  incident: 'badge--danger',
  feature: 'badge--info',
  general: 'badge--revoked',
};

export const SEVERITY_BADGE_CLASS: Record<AnnouncementSeverity, string> = {
  high: 'badge--danger',
  normal: 'badge--info',
  low: 'badge--revoked',
};

/** ISO 8601 -> ja-JP ローカル表示（日付+時刻） */
export const formatAnnouncementDate = (iso?: string): string => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};
